import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container, Typography } from '@mui/material';
import ShopCards from './components/ShopCards';
import ProductReviewForm from './components/Reseller/ProductReviewForm';
import ShopScrollList from './components/User/ShopGridSimple';
import ProductList from './components/User/ProductList';
import ProductDetail from './components/User/ProductDetail';
import CategorySelector from './components/User/CategorySelector';
import ResellerAccountForm from './components/Reseller/ResellerAccountForm';
import ResellerLoginPage from './components/Reseller/ResellerLoginPage';
import ResellerDashboard from './components/Reseller/ResellerDashboard';
import ResellerProfile from './components/Reseller/ResellerProfile';
import MyProductList from './components/Reseller/MyProductList';
import AuthPage from './components/User/AuthPage';
import ReviewHistory from './components/Reseller/ReviewHistory';
import UserData from './components/Admin/UserData';
import AdminPanel from './components/Admin/AdminPanel';
import UserSidebarLayout from './components/User/UserSidebarLayout';
import PublicResellerProfile from './components/User/PublicResellerProfile';
import LikedProducts from './components/User/LikedProducts';
import CartPage from './components/User/CartPage';
import NotificationsPage from './components/User/UserNotification'; // reuse for user
import NavbarBack from './components/User/NavbarBack'; // Navbar component
import FeedbackSection from './components/User/FeedbackSection';
import AdminLogin from './components/Admin/AdminLogin';
import AdminRegister from './components/Admin/AdminRegister';
import ReviewPlatformInfo from './components/AboutReviewPlatform';
import SearchById from './components/User/SearchById';
import HomePage from './components/HomePage';
import ProductCarousel from './components/ProductCarousel';
import ResendOfferForm from './components/Reseller/ResendOfferForm';
import ResendOfferList from './components/User/ResendOfferList';
import ResendOfferTable from './components/Reseller/ResendOfferTable';
import MessageBox from './components/Reseller/MessageBox';
import CategoryPage from './components/Admin/categoryData';
import SubCategory from './components/Admin/SubCategoryPage';
import { createTheme, ThemeProvider } from '@mui/material/styles';





function App() {
  return (
    <Router>
        <Routes>
          <Route path="/explore" element={<ShopCards />} />
          <Route path="/form" element={<ProductReviewForm />} />
          <Route path="/shop" element={<ShopScrollList />} />
          <Route path="/product" element={<ProductList/>} />
             <Route path="/product/:id" element={<ProductDetail />} />
             <Route path="/category" element={<CategorySelector />} />
             <Route path="/reseller-register" element={<ResellerAccountForm />} />
             <Route path="/reseller-login" element={<ResellerLoginPage />} />
             <Route path="/reseller-dashboard" element={<ResellerDashboard />} />
             <Route path="/profile" element={<ResellerProfile />} />
             <Route path="/my-products" element={<MyProductList />} />
             <Route path="/signin" element={<AuthPage />} />
             <Route path="/history" element={<ReviewHistory />} />
             <Route path="/admin-panel" element={<AdminPanel />} />
             <Route path="/menu" element={<UserSidebarLayout />} />
             <Route path="/reseller/:id" element={<PublicResellerProfile />} />
             <Route path="/liked-products" element={<LikedProducts />} />
             <Route path="/my-cart" element={<CartPage />} />
             <Route path="/notifications" element={<NotificationsPage />} />
             <Route path="/menus" element={<NavbarBack />} />
             <Route path="/feedback" element={<FeedbackSection />} />
             <Route path="/admin-login" element={<AdminLogin />} />
             <Route path="/admin-register" element={<AdminRegister />} />
             <Route path="/cat" element={<CategoryPage/>} />
             <Route path="/sub" element={<SubCategory/>} />
          
             <Route path="/a" element={<SearchById />} />
             <Route path="/" element={<HomePage/>} />
             <Route path="/offers" element={<ResendOfferList/>} />
             <Route path="/message" element={<MessageBox/>} />
              {/* <Route path="/category/:shirt" element={<ProductReviewApp />} /> */}
        </Routes>
    </Router>
  );
}

export default App;
